import React from 'react';

import { Category as CategoryInterface } from '../../../models/AuthModels';

import useInView from '../../../hooks/useInView';

import CourseContainer from '../../../components/Mols/CourseContainer';
import ShimmerCategoryContainer from '../../../components/Mols/Shimmer/CategoryContainer';

import { Container, CategoryTitle } from './styles';

interface CategoryRowProps {
  category: CategoryInterface;
  first: boolean;
}

/**
 * Uma fileira. Existe como componente próprio porque `useInView` é um hook e
 * precisa de uma instância por fileira — não pode ser chamado dentro do map.
 */
const CategoryRow: React.FC<CategoryRowProps> = ({ category, first }) => {
  const [rowRef, revealed] = useInView<HTMLElement>();

  return (
    <Container
      ref={rowRef}
      $first={first}
      $revealed={revealed}
      aria-labelledby={`category-${category.id}`}
    >
      <CategoryTitle>
        <h3 id={`category-${category.id}`}>{category.title}</h3>
        <p>{`(${category.courses.length})`}</p>
      </CategoryTitle>

      <CourseContainer
        courseViewType="horizontal"
        courses={category.courses}
        isLoading={false}
        label={category.title}
      />
    </Container>
  );
};

interface CategoryContainerProps {
  categories: Array<CategoryInterface>;
  isLoading: boolean;
}

const CategoryContainer: React.FC<CategoryContainerProps> = ({
  categories,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <>
        <ShimmerCategoryContainer />
        <ShimmerCategoryContainer />
        <ShimmerCategoryContainer />
      </>
    );
  }

  return (
    <>
      {categories.map((category, index) => (
        <CategoryRow
          key={category.id}
          category={category}
          first={index === 0}
        />
      ))}
    </>
  );
};

export default CategoryContainer;
